"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainContent = void 0;
var _react = require("react");
var _EnvironmentManager = require("./EnvironmentManager.provider");
var _main = require("../../main");
var _Modal = require("../../Layout/Modal");
var _SliderLayout = require("../../Layout/SliderLayout");
var _editorView = require("./sliderItemsViews/editorView");
var _schoolSelectionView = require("./sliderItemsViews/schoolSelectionView");
var _AudiencePickerView = require("./sliderItemsViews/AudiencePickerView");
var _EnvironmentSavedView = require("./sliderItemsViews/EnvironmentSavedView");
var _EnvironmentShareView = require("./sliderItemsViews/EnvironmentShareView");
var _EnvironmentDeleteView = require("./sliderItemsViews/EnvironmentDeleteView");
var _EnvironmentManager2 = _interopRequireDefault(require("./EnvironmentManager.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MainContent = props => {
  const styles = (0, _EnvironmentManager2.default)();
  const {
    layout = 'popup',
    mode,
    productInfo,
    environmentTitleMaxLength,
    enableRangeDateSelection = true,
    isLearingSite = false
  } = props;
  const {
    sliderView,
    preloaderMode,
    userSessionData,
    audiencePickerProvider,
    environmentData,
    getLabel
  } = (0, _react.useContext)(_EnvironmentManager.EnvironmentManagerContext);
  const {
    isSessionDataReady,
    userId,
    role
  } = userSessionData;
  const sliderIndex = ['schoolSelector', 'main', 'studentsSelector', 'createGroup', 'groupEdit', 'environmentSaved', 'share', 'environmentDelete'].indexOf(sliderView ?? '');
  const onClose = environmentDataToUseNow => {
    props?.onClose?.(environmentDataToUseNow);
  };
  const onSave = environmentData => {
    props?.onSave?.(environmentData, mode);
  };
  const onDelete = environmentData => {
    if (mode === 'update') {
      const {
        onDelete
      } = props;
      onDelete?.(environmentData);
    }
  };
  if (!getLabel || !(isSessionDataReady && userId && role !== 'student')) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-EnvironmentManager'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal, {
      id: "environmentManager",
      isOpen: true,
      isCloseFromOutsideEnabled: false,
      layout: layout,
      onClose: () => {
        onClose();
      },
      children: sliderIndex >= 0 && audiencePickerProvider.isAudiencePickerProviderReady ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SliderLayout.SliderLayout, {
        width: "100%",
        index: sliderIndex,
        items: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_schoolSelectionView.SliderSchoolSelectionView, {
          onClose: onClose
        }), mode === 'create' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_editorView.SliderEditorView, {
          productInfo: productInfo,
          mode: 'create',
          environmentTitleMaxLength: environmentTitleMaxLength,
          enableRangeDateSelection: enableRangeDateSelection,
          isLearingSite: isLearingSite,
          onClose: onClose,
          onSave: onSave
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_editorView.SliderEditorView, {
          productInfo: productInfo,
          mode: mode,
          environmentTitleMaxLength: environmentTitleMaxLength,
          enableRangeDateSelection: enableRangeDateSelection,
          sourceEnvironmentId: props.sourceEnvironmentId,
          isLearingSite: isLearingSite,
          onClose: onClose,
          onSave: onSave
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AudiencePickerView.AudiencePickerView, {
          view: "studentsSelector"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AudiencePickerView.AudiencePickerView, {
          view: "createGroup"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AudiencePickerView.AudiencePickerView, {
          view: "groupEdit"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EnvironmentSavedView.EnvironmentSavedView, {
          environmentTitle: environmentData.Title,
          mode: mode === 'update' ? 'updated' : 'created',
          onCloseAfterSave: onClose
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EnvironmentShareView.EnvironmentShareView, {
          environmentTitle: environmentData.Title,
          productInfo: productInfo,
          onClose: onClose
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EnvironmentDeleteView.EnvironmentDeleteView, {
          environmentTitle: environmentData.Title,
          isLearingSite: isLearingSite,
          onClose: onClose,
          onDelete: onDelete
        })],
        children: preloaderMode === 'over' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Preloader, {
          type: "over",
          width: 300
        })
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.Modal.Content, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.Preloader, {
          type: "inline",
          width: 300
        })
      })
    })
  });
};
exports.MainContent = MainContent;